import React from 'react';
import { v4 as uuid } from 'uuid';
import { MenuItemStyled, MenuStyled, ListItemTextStyled, ListItemIconStyled } from './menu.styles';

const SingleMenuItem = (props) => {
  const { item, handleClose, openSubMenu, variant = 'light', width = 200, noBorder } = props;
  const { title, icon, disabled, onClick, primary, config, backgroundColor } = item;

  return (
    <MenuItemStyled
      data-testid={title}
      variant={variant}
      width={width}
      noBorder={noBorder}
      onClick={(event) => {
        if (handleClose) handleClose();
        if (openSubMenu) openSubMenu(event?.currentTarget);
        onClick();
      }}
      disabled={disabled}
      primary={primary}
      hoverColor={config?.iconHoverColor}
      sx={{
        backgroundColor: backgroundColor ? `${backgroundColor} !important` : '',
      }}
    >
      {icon && <ListItemIconStyled>{icon}</ListItemIconStyled>}
      <ListItemTextStyled variant={variant} disableTypography>
        {title}
      </ListItemTextStyled>
    </MenuItemStyled>
  );
};

const NestedMenu = ({
  options,
  parentClose,
  parentElement,
  variant,
  width,
  paperSx,
  position,
  noBorder = false,
  anchorOrigin = { vertical: 'top', horizontal: 'left' },
  transformOrigin = { vertical: 'top', horizontal: 'right' },
}) => {
  const menuID = React.useRef(uuid());
  const open = Boolean(parentElement);

  const handleClose = () => {
    if (parentClose) parentClose(true);
  };

  const onClose = (event, reason) => {
    if (reason === 'backdropClick') {
      const closeParentOnBackdrop = false;
      if (parentClose) parentClose(closeParentOnBackdrop);
      return;
    }
    handleClose();
  };

  return (
    <MenuStyled
      id={`basic-menu-${menuID}`}
      anchorEl={parentElement}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          ...paperSx,
        },
      }}
      MenuListProps={{
        'aria-labelledby': `basic-button-${menuID}`,
      }}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
    >
      {options?.map((item, index) => {
        return (
          <SingleMenuItem
            key={`${index}-nested-menu`}
            item={item}
            handleClose={handleClose}
            variant={variant}
            width={width}
            noBorder={noBorder}
          />
        );
      })}
    </MenuStyled>
  );
};

export default NestedMenu;
